import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import { get } from 'lodash';

import BasicSelect from '../../../../../../shared/components/formComponents/groups/BasicSelect';
import { VerbRichTextEditor } from '../../../../../../shared/components/formComponents/VerbRichTextEditor';
import RichTextNotesHeader from '../RichTextNotesHeader';
import CopyAssetLink from '../../../../../components/CopyAssetLink';
import CategoriesFieldArray from './CategoriesArrayComponent';
import QuestionsFieldArray from './QuestionsArrayComponent';

const displayTypeOptions = [
    {
        label: 'Radio',
        value: 'radio'
    },
    {
        label: 'Image',
        value: 'image'
    }
];

class ThisOrThatPermutationSectionItem extends Component {
    static propTypes = {
        contentValues: PropTypes.object.isRequired,
        assetLinkOptions: PropTypes.array,
        memberReference: PropTypes.string,
        isGlobalSectionItem: PropTypes.bool
    };

    render() {
        const { memberReference, contentValues, isGlobalSectionItem } = this.props;
        const categories = get(contentValues, 'categories', []);
        const displayType = get(contentValues, 'displayType', 'radio');

        return (
            <div className={'permutationSectionItem'}>
                <Field
                    name={memberReference ? `${memberReference}.content.displayType` : 'content.displayType'}
                    label={'Display Type'}
                    options={displayTypeOptions}
                    component={BasicSelect}
                    className={'col-12'}
                    disabled={isGlobalSectionItem}
                />
                <div className={'row'}>
                    <div className={'col-7'}>
                        <Field
                            name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                            label={'Description'}
                            placeholder={'Enter a description'}
                            component={VerbRichTextEditor}
                            readOnly={isGlobalSectionItem}
                            rows={3}
                        />
                    </div>
                    <div className={'col-5 mt-4'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
                <FieldArray
                    name={memberReference ? `${memberReference}.content.categories` : 'content.categories'}
                    displayType={displayType}
                    component={CategoriesFieldArray}
                    disabled={isGlobalSectionItem}
                />
                <FieldArray
                    name={memberReference ? `${memberReference}.content.questions` : 'content.questions'}
                    categories={categories}
                    displayType={displayType}
                    component={QuestionsFieldArray}
                    disabled={isGlobalSectionItem}
                />
            </div>
        );
    }
}

export default ThisOrThatPermutationSectionItem;
